import { createFileRoute } from '@tanstack/react-router';
import SupplierLayout from '@components/layout/supplier/SupplierLayout.tsx';
import SupplierDashboard from '@features/supplier/dashboard/SupplierDashboard.tsx';

export const Route = createFileRoute('/s/$orgId/$portalId/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SupplierLayout>
      <SupplierDashboard />
    </SupplierLayout>
  );
}
